/** `DD.MM.YYYY HH:mm`, or an em dash when the value is missing/unparseable-empty. */
export function formatVersionDate(value?: string | null): string {
  if (!value) return '—';
  const at = new Date(value);
  if (Number.isNaN(at.getTime())) return value;
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${pad(at.getDate())}.${pad(at.getMonth() + 1)}.${at.getFullYear()} ${pad(at.getHours())}:${pad(at.getMinutes())}`;
}

/**
 * A version is in effect until it is closed. Go services serialise an unset
 * timestamp as `null`, an empty string or the zero date, so all three count as
 * "still open".
 */
export function isVersionActive(version: {
  end_at?: string | null | undefined;
}): boolean {
  const end = version.end_at;
  if (!end) return true;
  const at = new Date(end);
  return Number.isNaN(at.getTime()) || at.getUTCFullYear() <= 1;
}

/** `#12` — how a version id is shown in the UI. */
export function formatVersionId(id: string): string {
  return `#${id}`;
}
